import { render, staticRenderFns } from "./StudentGradeHistory.vue?vue&type=template&id=acbd9460&scoped=true"
import script from "./StudentGradeHistory.vue?vue&type=script&lang=ts"
export * from "./StudentGradeHistory.vue?vue&type=script&lang=ts"
import style0 from "./StudentGradeHistory.vue?vue&type=style&index=0&id=acbd9460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbd9460",
  null
  
)

export default component.exports